/**
 * MODELO DE PRECIO DEL ESTIMADOR — carril de BAÑO DE LUJO (ALL-IN).
 *
 * 🔴 CAMBIO vs versión masiva: el rango ahora es **all-in** = diseño + construcción +
 * un **allowance de acabados curados** (grifería, vanity, tope, tile, tina, iluminación).
 * Ya NO es "construcción sola con acabados aparte". Esto hace que el rango refleje la
 * inversión real de un baño de gama alta y que el gate de calificación ($25K) tenga sentido.
 *
 * Estructura mental para el lead:
 *   1) ROOM  → qué baño (tamaño) → adder por área
 *   2) SCOPE → qué trabajo (el driver principal)
 *   3) detalles (ducha / tina / vanity) → suben el nivel de acabado
 *
 * ⚠️ Números de ARRANQUE (calibración de lujo). Javier / VonJorge los afinan contra
 * históricos reales de JobTread (engine v6.17). El midpoint mapea a tier interno.
 */
export const PRICING = {
  // 1) Tamaño del baño = adder por área
  room: {
    half: [0, 0], // powder — rara vez es carril de lujo; ancla bajo para autodescartar
    secondary: [4000, 8000],
    master: [10000, 20000],
  },
  // 2) Alcance del trabajo = costo principal (diseño + obra all-in)
  scope: {
    full: [18000, 30000], // gut completo + diseño + acabados curados
    shower: [10000, 16000], // reconstruir solo la ducha, gama alta
    tub_to_shower: [12000, 18000],
    refresh: [10000, 16000], // todo menos la ducha
  },
  // 3a) Upgrade del tipo de ducha (delta sobre walk-in base)
  showerType: {
    walkin: [0, 0],
    wetroom: [3000, 6000], // curbless / wet room
    spa: [5000, 9000], // rain + body spray, sistema spa
  },
  // 3b) Tina (unidad + plomería + labor)
  tub: { none: [0, 0], freestanding: [3000, 6000], combo: [2000, 4000] },
  // 3c) Vanity (unidad + plomería + blocking)
  vanity: { single: [2000, 4000], double: [4000, 7000] },
} as const;

/** Suma [min,max] de las selecciones y devuelve el rango + tier por midpoint (interno). */
export function computeRange(mins: number[], maxs: number[]) {
  const min = mins.reduce((a, b) => a + b, 0);
  const max = maxs.reduce((a, b) => a + b, 0);
  const mid = (min + max) / 2;
  // Tiers de lujo: Signature $25–40K · Spa/Primary $40–70K · Estate $70K+
  const band = mid < 40000 ? "A" : mid < 70000 ? "B" : "C";
  return { min, max, band };
}
